import React, { useState } from "react";
import { Container, Typography, Box, Link } from "@mui/material";



const articles = [
  { id: 1, title: "Is CTMS Dead?", author: "Heather Kellerman", 
    date: "March 14, 2022",
    description: "Clinical trials are pivotal for medical advancements, offering new treatment possibilities and better patient outcomes. However, their complexity, which involves various stakeholders, unique processes, and extensive data, can be daunting. To streamline operations, ensure regulatory compliance, and achieve successful outcomes, organizations require a robust Clinical Trial Management Software (CTMS) solution. Intrinsic CTMS is designed to […] ...", 
    image: "/news1.png" },
  { id: 2, title: "Conference: SCOPE 14th Annual – February 6-9, 2023", author: "Heather Kellerman", date: "January 16, 2023",
    description: "Join Intrinsic Clinical Systems at the 14th Annual Scope Conference ...", image: "/news1.png" },
      { id: 1, title: "Is CTMS Dead?", author: "Heather Kellerman", date: "March 14, 2022",
    description: "At Intrinsic, we’ve been implementing Clinical Trial Management Systems (CTMSs) ...", image: "/news1.png" },
  { id: 2, title: "Conference: SCOPE 14th Annual – February 6-9, 2023", author: "Heather Kellerman", date: "January 16, 2023",
    description: "Join Intrinsic Clinical Systems at the 14th Annual Scope Conference ...", image: "/news1.png" },
      { id: 1, title: "Is CTMS Dead?", author: "Heather Kellerman", date: "March 14, 2022",
    description: "At Intrinsic, we’ve been implementing Clinical Trial Management Systems (CTMSs) ...", image: "/news1.png" },
  { id: 2, title: "Conference: SCOPE 14th Annual – February 6-9, 2023", author: "Heather Kellerman", date: "January 16, 2023",
    description: "Join Intrinsic Clinical Systems at the 14th Annual Scope Conference ...", image: "/news1.png" },
      { id: 1, title: "Is CTMS Dead?", author: "Heather Kellerman", date: "March 14, 2022",
    description: "At Intrinsic, we’ve been implementing Clinical Trial Management Systems (CTMSs) ...", image: "/news1.png" },
  { id: 2, title: "Conference: SCOPE 14th Annual – February 6-9, 2023", author: "Heather Kellerman", date: "January 16, 2023",
    description: "Join Intrinsic Clinical Systems at the 14th Annual Scope Conference ...", image: "/news1.png" },
      { id: 1, title: "Is CTMS Dead?", author: "Heather Kellerman", date: "March 14, 2022",
    description: "At Intrinsic, we’ve been implementing Clinical Trial Management Systems (CTMSs) ...", image: "/news1.png" },
  { id: 2, title: "Conference: SCOPE 14th Annual – February 6-9, 2023", author: "Heather Kellerman", date: "January 16, 2023",
    description: "Join Intrinsic Clinical Systems at the 14th Annual Scope Conference ...", image: "/news1.png" },
      { id: 1, title: "Is CTMS Dead?", author: "Heather Kellerman", date: "March 14, 2022",
    description: "At Intrinsic, we’ve been implementing Clinical Trial Management Systems (CTMSs) ...", image: "/news1.png" },
  { id: 2, title: "Conference: SCOPE 14th Annual – February 6-9, 2023", author: "Heather Kellerman", date: "January 16, 2023",
    description: "Join Intrinsic Clinical Systems at the 14th Annual Scope Conference ...", image: "/news1.png" },
  // add more unique articles...
];

export default function NewsEvents() {
  const itemsPerPage = 5;
  const [page, setPage] = useState(0);

  const startIndex = page * itemsPerPage;
  const currentArticles = articles.slice(startIndex, startIndex + itemsPerPage);

  return (
    <Box
      sx={{
        background: "linear-gradient(to bottom, white 0%, #e6f7ff 100%)",
        minHeight: "100vh",
        pb: 6
      }}
    >
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 4,
            textAlign: "center",
            color: "#2b2b2b",
            letterSpacing: 0.5
          }}
        >
          NEWS & EVENTS
        </Typography>

        {currentArticles.map((article, index) => (
          <Box
            key={`article-${startIndex + index}`}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" }, // stacked on small screens, side-by-side on md+
              alignItems: "flex-start",
              gap: 2,
              py: 3,
              borderBottom: "1px solid rgba(0,0,0,0.06)"
            }}
          >
            {/* Image column (fixed) */}
            <Box
              sx={{
                flex: "0 0 200px", // fixed size column
                width: 200,
                height: 200,
                borderRadius: 2,
                background: "#ebf8fb",
                p: 1.2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Box
                component="img"
                src={article.image}
                alt={article.title}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 1
                }}
              />
            </Box>

            {/* Text column (flexible) */}
            <Box sx={{ flex: 1, minWidth: 0 /* IMPORTANT to allow shrinking */ }}>
              <Link
                href="#"
                underline="none"
                sx={{
                  display: "block",
                  fontSize: { xs: "1.05rem", md: "1.25rem" },
                  fontWeight: 500,
                  color: "#00AEEF",
                  mb: 1,
                  "&:hover": { textDecoration: "underline" }
                }}
              >
                {article.title}
              </Link>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {article.author} | {article.date}
              </Typography>

              <Typography variant="body1" sx={{ color: "#333", lineHeight: 1.7 }}>
                {article.description}
              </Typography>
            </Box>
          </Box>
        ))}

        {/* Pagination */}
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          {page > 0 && (
            <Link
              component="button"
              onClick={() => setPage((p) => p - 1)}
              sx={{ color: "#00AEEF" }}
            >
              ← newer
            </Link>
          )}
          {(page + 1) * itemsPerPage < articles.length && (
            <Link
              component="button"
              onClick={() => setPage((p) => p + 1)}
              sx={{ color: "#00AEEF" }}
            >
              older →
            </Link>
          )}
        </Box>
      </Container>
    </Box>
  );
}
